import { useState, useEffect, useRef } from "react";

export function useMultipleModal() {
  const [openModals, setOpenModals] = useState<Record<string, boolean>>({});
  const modalRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const isOpenModal = (modalKey: string) => !!openModals[modalKey];

  const toggleModalVisibility = (modalKey: string) => {
    setOpenModals((prev) => ({
      ...prev,
      [modalKey]: !prev[modalKey],
    }));
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      Object.keys(modalRefs.current).forEach((modalKey) => {
        const modalRef = modalRefs.current[modalKey];
        if (
          modalRef &&
          !modalRef.contains(event.target as Node) &&
          isOpenModal(modalKey)
        ) {
          toggleModalVisibility(modalKey);
        }
      });
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openModals]);

  const assignRef = (modalKey: string, ref: HTMLDivElement | null) => {
    modalRefs.current[modalKey] = ref;
  };

  return { isOpenModal, toggleModalVisibility, assignRef };
}
